import PropTypes from 'prop-types';

import 'components/Filter/Filter.less';

const Filter = ({ settings, actions }) => (
    <div className="admin-filter">
        <div className="admin-filter__settings">{settings}</div>
        <div className="admin-filter__actions">{actions}</div>
    </div>
);

Filter.propTypes = {
    settings: PropTypes.node,
    actions: PropTypes.node,
};

export default Filter;
